import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\UpdatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/UpdatePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
const UpdatePaymentModeController = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePaymentModeController.url(args, options),
    method: 'put',
})

UpdatePaymentModeController.definition = {
    methods: ["put"],
    url: '/api/payment-mode/{payment_mode}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\PaymentMode\UpdatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/UpdatePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
UpdatePaymentModeController.url = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_mode: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment_mode: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment_mode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_mode: typeof args.payment_mode === 'object'
        ? args.payment_mode.id
        : args.payment_mode,
    }

    return UpdatePaymentModeController.definition.url
            .replace('{payment_mode}', parsedArgs.payment_mode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\UpdatePaymentModeController::__invoke
* @see app/Http/Controllers/PaymentMode/UpdatePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
UpdatePaymentModeController.put = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePaymentModeController.url(args, options),
    method: 'put',
})

export default UpdatePaymentModeController